import angular from 'angular';
import modalConfirmation from '../../../shared/components/modal-response/modal-response.view.html';
let inject = [
  '$scope',
  'CategoryService',
  '$state',
  '$rootScope',
  'SharedService',
  '$stateParams',
  '$uibModal',
  '$timeout',
  'Pagination',
  'SessionService',
  'CategoryProductsService',
  '$filter',
  'ngAuthSettings'
];

class CategoryController{
  constructor ($scope,
               CategoryService,
               $state,
               $rootScope,
               SharedService,
               $stateParams,
               $uibModal,
               $timeout,
               Pagination,
               SessionService,
               CategoryProductsService,
               $filter,
               ngAuthSettings) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.Pagination = Pagination;
    this.SessionService = SessionService;
    this.$stateParams = $stateParams;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.CategoryService = CategoryService;
    this.$timeout = $timeout;
    this.SharedService = SharedService;
    this.CategoryProductsService = CategoryProductsService;
    this.$filter = $filter;
    this.loanding = false;
    this.pagerCategories = [];
    this.itemsPerPage = 12;
    this.loadingCategories = true;
    this.categoryId = this.$stateParams.idCategory || '';
    this.categorySlug = this.$stateParams.categorySlug || '';
    this.productSale = this.$stateParams.productSale || '';
    this.productsList = [];
    this.productHighPriceTest = 0;
    this.productLowPriceTest = 0;
    this.categoryAttributes = [];
    this.categoryProductAttributes = [];
    this.categoryAttributesGroups = [];
    this.filterAttributesProducts = {};
    this.loadingProducts = false;
    this.pageSize = 24;
    this.currentPage = 1;
    this.totalItems = 1;
    this.controlPrice = 0;
    this.sortType = 1;
    this.searchText = '';
    this.typeview = 1;
    this.dataFilter = {};
    this.localFilters = null;

    this.ctrlTest = 3;
    this.initializeTest = false;

    this.customFilters = {
      productHighPrice : null,
      productLowPrice : null,
      productHighPriceTest : null,
      productLowPriceTest : null
    };
  }

  $onInit(){
    this.dataFilter = this.CategoryProductsService.getFiltersData();
    if(this.$stateParams.idCategory || this.$stateParams.categorySlug){
      if(this.dataFilter){
        if(this.$stateParams.categorySlug === this.dataFilter.slug || this.$stateParams.idCategory === this.dataFilter.id){
          this.pageSize = this.dataFilter.pageSize;
          this.currentPage = this.dataFilter.pageNumber;
          this.searchText = this.dataFilter.internSearchText;
          this.customFilters.attributes = this.dataFilter.filters.attributes;
          this.customFilters.productHighPriceTest = this.dataFilter.filters.productHighPrice;
          this.customFilters.productLowPriceTest = this.dataFilter.filters.productLowPrice;
          this.sortType = this.dataFilter.filters.sort;
          this.getCurrentCategory();
        } else {
          this.CategoryProductsService.setFiltersData(null);
          this.getCurrentCategory();
        }
      } else {
        this.getCurrentCategory();
      }
    } else if(this.$stateParams.searchText) {
      if(this.dataFilter){
        if(this.$stateParams.searchText === this.dataFilter.searchText){
          this.pageSize = this.dataFilter.pageSize;
          this.currentPage = this.dataFilter.pageNumber;
          this.searchText = this.dataFilter.internSearchText;
          this.customFilters.attributes = this.dataFilter.filters.attributes;
          this.customFilters.productHighPriceTest = this.dataFilter.filters.productHighPrice;
          this.customFilters.productLowPriceTest = this.dataFilter.filters.productLowPrice;
          this.sortType = this.dataFilter.filters.sort;
          this.getProducts();
        } else {
          this.CategoryProductsService.setFiltersData(null);
          this.getProducts();
        }
      } else {
        this.getProducts();
      }
    }
  }

  confirmTimerTest() {
    this.$timeout(() =>{
      this.timerTest();
    }, 1000);
  }

  timerTest() {
    if(this.ctrlTest > 0) {
      this.ctrlTest--;
      this.confirmTimerTest();
    }
    else {
      this.getProducts();
      this.initializeTest = false;
    }
  }

  onChangePriceFilter (){
    if(this.initializeTest) this.ctrlTest = 3;
    else {
      this.initializeTest = true;
      this.timerTest();
    }
  };

  /**
   Get current category
   @method getCurrentCategory
   */
  getCurrentCategory () {
    this.CategoryService.getCurrentCategory(this.$stateParams.idCategory, this.$stateParams.categorySlug).then(response => {
      this.currentCategory = response;
      if(!this.categoryId) {
        this.categoryId = response.id;
      }
      this.getAttributesCategory(this.$stateParams.idCategory, this.$stateParams.categorySlug);
    }).catch(reason => {
      console.log(reason);
      this.$state.go('404');
    });
  }

  getAttributesCategory (idCategory, categorySlug) {
    this.CategoryService.getAttributesCategory(idCategory, categorySlug).then(response => {
      this.categoryAttributes = response;
      this.getProducts();
    }).catch(reason => {
      console.log(reason);
      this.$state.go('404');
    });
  };

  getProducts(footer, cleanFilter, footerPlace) {
    if(this.loadingProducts) return;
    this.loadingProducts = true;
    let searchText = this.$stateParams.searchText;
    //this.controlPrice = this.searchText ? 0 : this.controlPrice;
    this.searchText = (cleanFilter ? '' : this.searchText);
    if(!searchText) searchText = '';
    let userId = '';
    try{ userId = this.shCtrl.globals.currentUser.userId; }
    catch(e){}
    if(footer){
      this.scrollProductListToTop();
    }
    let data = {
      id : this.categoryId,
      slug : this.categorySlug,
      pageSize : this.pageSize,
      pageNumber : this.currentPage,
      searchText : decodeURIComponent(searchText),
      internSearchText : this.searchText,
      userId : userId,
      filters : {
        attributes : (cleanFilter ? null : this.customFilters.attributes),
        productHighPrice : (cleanFilter ? 0 : this.customFilters.productHighPriceTest),
        productLowPrice : (cleanFilter ? 0 : this.customFilters.productLowPriceTest),
        sort : this.sortType
      }
    };
    this.CategoryProductsService.getProducts(data, this.$stateParams.productSale).then(response => {
      this.pageSize = (this.pageSize > response.cantidadTotal ? 24 : this.pageSize);
      this.totalItems = angular.copy(response.cantidadTotal);
      this.totalPages = angular.copy(response.totalPage);

      if(response.items.length){
        //there is data on the back page?
        if(this.dataFilter && ((this.categorySlug && this.categorySlug === this.dataFilter.slug) || (searchText && decodeURIComponent(searchText) === this.dataFilter.searchText))){
          this.currentPage = this.dataFilter.pageNumber;
          if(!this.controlPrice){
            this.customFilters.productHighPriceTest = this.dataFilter.filters.productHighPrice;
            this.customFilters.productLowPriceTest = this.dataFilter.filters.productLowPrice;
            this.controlPrice++;
          }
        }else{
          if(!this.controlPrice){
            this.customFilters.productHighPriceTest = response.highestPrice;
            this.customFilters.productLowPriceTest = 0;
            this.controlPrice++;
          }
        }

        this.customFilters.productHighPrice = response.highestPrice;
        this.customFilters.productLowPrice = response.lowestPrice;
        this.dataFilter = {};
        this.productsList = angular.copy(response.items);
        this.loadingProducts = false;
        this.localFilters = angular.copy(this.customFilters.attributes);
        this.activateProducts(this.customFilters);
        let resultView = this.SessionService.get('itemsView');
        if(!resultView){
          if($(window).width() >= 1200) {
            this.setCookieItemsView(this.shCtrl.globalParams.itemsView.pc);
          }else if($(window).width() < 1200) {
            this.setCookieItemsView(this.shCtrl.globalParams.itemsView.tablet);
          }
        } else {
          this.setCookieItemsView(resultView);
        }
      } else {
        if(searchText && !this.searchText){
          this.$state.go('home.productNotFount', {productSearchText : searchText});
        }else{
          this.productsList = [];
          this.loadingProducts = false;
          this.controlPrice = 1;
        }
      }
    }).catch(reason => {
      this.loadingProducts = false;
      this.localFilters = angular.copy(this.customFilters.attributes);
    });

  }

  activateProducts(item) {
    this.sliderOptions = {
      options : {
        showSelectionBar: true,
        selectionBarGradient: {
          from: this.ngAuthSettings.site.info.style.secondColor,
          to: this.ngAuthSettings.site.info.style.secondColor
        },
        getPointerColor: (value) => {
          return this.ngAuthSettings.site.info.style.mainColor;
        },
        floor: 0,
        step: 1,
        minRange: 10,
        ceil: item.productHighPrice,
        noSwitching: true,
        onEnd : (sliderId, modelValue, highValue) => {
          this.getProducts();
        },
        translate: (value) => {
          return (this.$filter('currency')(value, '$', 0));
        }
      }
    };
    this.$timeout(() => {
      this.$scope.$broadcast('rzSliderForceRender');
    }, 1000);
  };

  scrollProductListToTop () {
    $('html, body').animate({
      'scrollTop': $('#breadcrumb-container').offset().top
    }, 1200);
  }


  updateProductAttribute (group, value, addRemove, att, val) {
    if(!this.categoryProductAttributes[group]) {
      this.categoryAttributesGroups.push(group);
      this.categoryProductAttributes[group] = [];
    }
    if(!this.filterAttributesProducts.hasOwnProperty(att)){
      this.filterAttributesProducts[att] = [];
    }
    if(addRemove){
      this.categoryProductAttributes[group].push(value);
      this.filterAttributesProducts[att].push(val);
    }
    else {
      let indexOf = this.categoryProductAttributes[group].indexOf(value);
      this.categoryProductAttributes[group].splice(indexOf, 1);
      let indexOfFilter = this.filterAttributesProducts[att].indexOf(val);
      this.filterAttributesProducts[att].splice(indexOfFilter, 1);
    }
    // this result = Object.keys(this.filterAttributesProducts);
    // this resultToCopy = {};
    // result.forEach(function(val){
    //     resultToCopy[val] = this.categoryProductAttributes[val];
    // });

    this.customFilters.attributes = angular.copy(this.filterAttributesProducts);
    this.getProducts();
  }

  changeInternalWordSearch(){
    this.controlPrice = 0;
  }

  compareProductsSelected() {
    let keys = Object.keys(this.productsToCompare.items);
    this.$state.go('/products/compare/' + this.categoryId + '/' + keys.join('-'));
  }

  cleanFilters(){
    if(this.customFilters.attributes){
      let keyAttributes = Object.values(this.customFilters.attributes);
      if(keyAttributes.length){
        this.customFilters.attributes = {};
        this.loadInitialAttributesFitler();
      }else{
        this.customFilters.attributes = {};
      }
    }else{
      this.customFilters.attributes = {};
    }
    this.controlPrice = 0;
    this.getProducts(false, true);
  }

  loadInitialAttributesFitler(){
    let keyArray = Object.keys(this.customFilters.attributes);
    this.filterAttributesProducts = angular.copy(this.customFilters.attributes);
    if(this.categoryAttributes){
      this.categoryAttributes.forEach(attr => {
        if(keyArray.length){
          keyArray.forEach(attrId =>{
            if(attr.id === parseInt(attrId)){
              attr.data.forEach(opcion => {
                this.customFilters.attributes[attrId].forEach(elId => {
                  if(opcion.id === elId){
                    opcion.name = true;
                  }
                });
              });
            }
          });
        }else{
          attr.data.forEach(opcion => {
            opcion.name = false;
          });
        }
      });
    }
  }

  setPagination (type, footer) {
    this.pageSize = type;
    this.getProducts(footer);
  }

  setSort (type, footer) {
    this.sortType = type;
    this.getProducts(footer);
  }

  setCookieItemsView (itemView) {
    itemView = parseInt(itemView);
    this.typeview = itemView;
    this.SessionService.put('itemsView', itemView);
  };

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

CategoryController.$inject = inject;

export default CategoryController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/category/category-products/category-products.controller.js
 **/